// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__24Vte","label":"Category_label__A62pI","content":"Category_content__md8p3","header":"Category_header__1TrCA","location":"Category_location__Kztx4"};